import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "el-table__column" };
const _hoisted_2 = { class: "data-inconsistency-table__tooltip" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px ml--4" }, null, -1);
export default /*#__PURE__*/ _defineComponent({
    __name: 'DataInconsistencyTableTooltip',
    props: {
        labelName: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_el_popover = _resolveComponent("el-popover");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("label", null, _toDisplayString(props.labelName), 1),
                _createVNode(_component_el_popover, {
                    trigger: "hover",
                    placement: "bottom",
                    width: 190
                }, {
                    reference: _withCtx(() => [
                        _hoisted_3
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('integrations.data-inconsistency.acceptable-error-tooltip')), 1)
                        ])
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
